__turbopack_context__.v({
  "intro": "juipJW_intro",
  "itemCell": "juipJW_itemCell",
  "itemsWrapper": "juipJW_itemsWrapper",
});
